window.DayImg6 = () => {
  var activeImgUrl =
    'https://cdn.marvel.com/content/u/open-html-assets/marketing-whatif/kahhori6.f9b92923.png';
  document.querySelector('#Six img').src = activeImgUrl;
};

trackingSix = () => {
  var eventType = 'what if season 2 redeem gift';
  var eventData = {
    linkLocation: 'Six',
    linkName: 'Redeem',
    linkDestination:
      'https://www.marvel.com/mu-23whatif?cid=Dcom_WhatIf_20231227_unlimited_calendar',
  };

  if (window['_satellite'] && window['digitalData']) {
    window['digitalData'].eventData = eventData;

    if (window['_satellite'].track) {
      window['_satellite'].track(eventType);
    }
  }
};

window.Day6 = () => {
  window['digitalData'].eventData = {};
  // Day Six Video
  document.getElementById('dialog__video').innerHTML =
    '<iframe width="640" height="480"  src="https://www.youtube.com/embed/mt7iXDMUGLw?si=Iu1Xo_-sKbSaO2pj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
  var videoDesc =
    'Here’s an early look from What If…Kahhori Reshaped the World?*Please note the events depicted in this scene are intended to be an alternate history.';
  // Day Six Gift
  var giftPrompt =
    'You’ve scored a month of Marvel Unlimited for FREE!* Enjoy instant access to over 30,000 digital comics. Use code <span id="daysix__code" > WHATIF </span> at checkout!*';
  var giftHTML =
    '<img class="daysix__gift" src="https://cdn.marvel.com/content/u/open-html-assets/marketing-whatif/Day6Gift.eac29b21.png" width="500px" height="250px">\r\n<a  target="_blank" href="https://www.marvel.com/mu-23whatif?cid=Dcom_WhatIf_20231227_unlimited_calendar" title="Redeem Code">\r\n <div id="dayseven__download" onclick="trackingSix()" class="cta-btn cta-btn--solid cta-btn--red ">\r\n <div  class="innerFill" > Redeem </div>\r\n </div> \r\n </a> \r\n <p id="dialog__legal"> *Offer available between December 26, 2023 at 9AM PST and December 31, 2023 at 12AM PST. Auto-renewal and other terms and conditions apply. US residents only. Please See marvel.com/mu-23whatif for more info.</p>';

  document.getElementById('dialog__title').textContent = 'EPISODE 6';
  document.getElementById('dialog__gift').innerHTML = giftHTML;
  document.getElementById('gift__desc').innerHTML = giftPrompt;
  document.getElementById('dialog__desc').innerHTML = videoDesc;

  var shardEvent = "what if season 2 shard click";
  var shardData = { 
   linkLocation : "Six",
   linkName : "Six",
  }
  if (window['_satellite'] && window['digitalData']) {
     window['digitalData'].eventData = shardData;
 
     if (window['_satellite'].track) {
       window['_satellite'].track(shardEvent);
     }
  }
};
